/**
 * Lazy getter for AuthManager to avoid circular dependency issues
 */

let authManagerInstance: any = null;

export async function getAuthManager() {
  if (!authManagerInstance) {
    const module = await import('./auth-manager');
    authManagerInstance = module.authManager;
  }
  return authManagerInstance;
} 